(function () {
  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function cardSize(index) {
    switch (index % 5) {
      case 1:
        return 'tall';
      case 2:
        return 'wide';
      case 4:
        return 'tall';
      default:
        return 'standard';
    }
  }

  function buildCard(review, index) {
    var li = document.createElement('li');
    li.className = 'aycan-reviews__card aycan-reviews__card--' + cardSize(index);
    li.setAttribute('data-ewa-review-card', '');

    var quote = review.quote || '';
    var author = review.author || '';
    var authorDisplay = author && author.indexOf('@') !== 0 ? '@' + author : author;
    var dateHtml = review.date ? '<span class="aycan-reviews__badge">' + escapeHtml(review.date) + '</span>' : '';
    var pillHtml = '';
    if (review.rating > 0) {
      pillHtml =
        '<span class="aycan-reviews__pill" role="img" aria-label="' +
        review.rating +
        ' out of 5 stars">' +
        '<span class="aycan-reviews__pill-star-wrap">' +
        '<svg class="aycan-reviews__pill-star" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
        '<path d="M8 0.5L10.24 5.04L15.25 5.77L11.63 9.3L12.48 14.29L8 11.93L3.52 14.29L4.37 9.3L0.75 5.77L5.76 5.04L8 0.5Z" fill="currentColor"/></svg></span>' +
        '<span class="aycan-reviews__pill-label">' + review.rating + '.0</span>' +
        '<span class="aycan-reviews__pill-sep"></span>' +
        '<span class="aycan-reviews__pill-verified">' +
        '<svg class="aycan-reviews__pill-check" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
        '<path d="M2.5 6L5 8.5L9.5 3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Verified</span></span>';
    }

    li.innerHTML =
      '<article class="aycan-reviews__frame" tabindex="0">' +
      '<img src="' +
      escapeHtml(review.image_url) +
      '" alt="' +
      escapeHtml(quote.slice(0, 80)) +
      '" class="aycan-reviews__img" loading="lazy" width="540" height="720" onerror="this.closest(\'.aycan-reviews__card\').remove();">' +
      pillHtml +
      '<div class="aycan-reviews__sheet">' +
      (quote ? '<blockquote class="aycan-reviews__quote">"' + escapeHtml(quote) + '"</blockquote>' : '') +
      '<footer class="aycan-reviews__meta">' +
      (authorDisplay ? '<cite class="aycan-reviews__author">' + escapeHtml(authorDisplay) + '</cite>' : '') +
      dateHtml +
      '</footer></div></article>';

    return li;
  }

  document.querySelectorAll('[data-ewa-reviews]').forEach(function (root) {
    var dataEl = root.querySelector('[data-ewa-reviews-data]');
    var grid = root.querySelector('[data-ewa-reviews-grid]');
    var btn = root.querySelector('[data-ewa-reviews-more]');
    var countEl = root.querySelector('[data-ewa-reviews-count]');

    if (!dataEl || !grid || !btn) return;

    var catalog;
    try {
      catalog = JSON.parse(dataEl.textContent);
    } catch (err) {
      btn.hidden = true;
      return;
    }

    var batchSize = parseInt(root.dataset.batchSize, 10) || 48;
    var cursor = grid.querySelectorAll('[data-ewa-review-card]').length;

    function updateCount() {
      if (!countEl) return;
      countEl.textContent = 'Showing ' + Math.min(cursor, catalog.length) + ' of ' + catalog.length;
    }

    btn.addEventListener('click', function () {
      var slice = catalog.slice(cursor, cursor + batchSize);
      slice.forEach(function (review, i) {
        grid.appendChild(buildCard(review, cursor + i + 1));
      });
      cursor += slice.length;
      updateCount();
      if (cursor >= catalog.length) btn.hidden = true;
    });

    updateCount();
  });
})();
